import React, { useEffect, useState } from "react";
import Modal from "../../../../components/Modal";
import ChooseAddress from "../../../../components/ChooseAddress";
import { getLocationObj, setItemStore } from "../../../../untils";
import { locationProps } from "../../../../models/orderModel";
import { TranslationObject } from "../../../../models/translationModal";
import cn from "classnames";
import {
    SPECIALIST_ADDRESS,
    MY_ADDRESS,
} from "../../../../store/order/constant";
import {
    getItemCreateOrder,
    getItemEditOrder,
} from "../../../../store/order/selectors";
import { endpoints } from "../../../../store/user/user.api";

const SpecialistAddressModal: React.FC<{
    entities?: TranslationObject;
    showSpecialistAddressModal: boolean;
    close: () => void;
    save: (location: locationProps) => void;
    isSpecialist?: boolean;
    isEdit?: boolean;
    errorRequired?: boolean;
    isOpenOrder?: boolean;
    showUserAddress?: boolean;
}> = ({
    entities,
    showSpecialistAddressModal,
    close,
    save,
    isSpecialist = false,
    isEdit,
    errorRequired = false,
    isOpenOrder,
    showUserAddress = false,
}) => {
    const [location, setLocation] = useState<locationProps | null>(null);
    const [tempLocation, setTempLocation] = useState<locationProps | null>(
        null
    );
    const specialistCoordinates = isEdit
        ? getItemEditOrder(SPECIALIST_ADDRESS)
        : getItemCreateOrder(SPECIALIST_ADDRESS);
    const { data: profile } = endpoints.getProfile.useQuery();
    const myCoordinates = isEdit
        ? getItemEditOrder(MY_ADDRESS)
        : getItemCreateOrder(MY_ADDRESS);

    useEffect(() => {
        if (profile) {
            const { address, latitude, longitude } = profile || {};

            if (address && latitude && longitude) {
                if (
                    !specialistCoordinates ||
                    (address && specialistCoordinates.address !== address) ||
                    (latitude && specialistCoordinates.latitude !== latitude) ||
                    (longitude && specialistCoordinates.longitude !== longitude)
                ) {
                    const initialLocation = {
                        latitude: latitude,
                        longitude: longitude,
                        address: address,
                    };
                    setLocation(initialLocation);
                    setTempLocation(initialLocation);
                    return;
                }
            }
        }

        if (specialistCoordinates) {
            const initialLocation = getLocationObj(specialistCoordinates);
            setLocation(initialLocation);
            setTempLocation(initialLocation);
            return;
        }
    }, [profile, specialistCoordinates, isOpenOrder, showUserAddress]);

    useEffect(() => {
        if (!showSpecialistAddressModal) {
            setTempLocation(location);
        }
    }, [showSpecialistAddressModal, location]);

    const changeLocation = (obj: locationProps) => {
        setTempLocation({
            latitude: obj?.latitude,
            longitude: obj?.longitude,
            radius: obj?.radius,
            address: obj?.address,
        });
    };

    const handleSave = () => {
        if (tempLocation && !disabledButtonSave) {
            save(tempLocation);
            setLocation(tempLocation);

            if (!isEdit) {
                setItemStore("specialist_address", {
                    latitude: tempLocation?.latitude,
                    longitude: tempLocation?.longitude,
                    radius: tempLocation?.radius,
                    address: tempLocation?.address,
                });
            }
        }
    };

    const handleCancel = () => {
        setTempLocation(location);
        close();
    };

    const disabledButtonSave =
        !tempLocation?.latitude ||
        !tempLocation?.longitude ||
        !tempLocation?.radius ||
        !tempLocation?.address;

    return (
        <Modal
            visible={showSpecialistAddressModal}
            key="SpecialistAddressModal"
            modificators={[
                !isSpecialist ? "customer" : "",
                "modal-specialist address-modal",
            ]}
            onClose={handleCancel}
            title={
                isSpecialist
                    ? entities?.common_customer_adress?.value
                    : entities?.order_select_meeting_address_title?.value
            }
            description={`${
                isSpecialist
                    ? entities?.specialist_details_distance?.value
                    : entities?.order_details_distance?.value || ""
            }`}
        >
            <form className="form">
                <ChooseAddress
                    inputClasses={["custom-input--suffix form__field"]}
                    changeLocation={changeLocation}
                    withRadius={true}
                    entities={entities}
                    location={tempLocation}
                    isSpecialist={isSpecialist}
                    isRequired={true}
                    errorRequired={errorRequired}
                />
                <div className="form__row form__controls form__row--end">
                    <button
                        className="btn form__control form__back-link btn--transparent"
                        type="button"
                        onClick={handleCancel}
                    >
                        {entities?.common_cancel_button?.value}
                    </button>
                    <button
                        className={cn("btn form__control", {
                            "btn--bg-green": isSpecialist,
                        })}
                        type="button"
                        onClick={handleSave}
                        disabled={disabledButtonSave}
                    >
                        {entities?.common_save_button?.value}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default SpecialistAddressModal;
